// extracted by mini-css-extract-plugin
export var addressFields = "_je-0";
export var animationContainer = "_je-1";
export var footer = "_je-2";
export var lineItems = "_je-3";
export var modalContent = "_je-4";
export var orderName = "_je-5";
export var strong = "_je-6";
export var warning = "_je-7";